import { motion } from "framer-motion";
import { FiSmartphone, FiHome, FiShield, FiDatabase } from "react-icons/fi";

const products = [
  {
    name: "Firewall Device",
    type: "Hardware Device",
    status: "Available",
    icon: <FiShield />,
    color: "from-orange-500 to-gray-700",
  },
  {
    name: "Backup Device",
    type: "Hardware Device",
    status: "Available",
    icon: <FiDatabase />,
    color: "from-orange-500 to-gray-700",
  },
  {
    name: "Real Estate Application",
    type: "Application",
    status: "Coming Soon",
    icon: <FiHome />,
    color: "from-gray-400 to-orange-400",
  },
  {
    name: "Home Services Application",
    type: "Application",
    status: "Coming Soon",
    icon: <FiSmartphone />,
    color: "from-gray-400 to-orange-400",
  },
];

export default function ProductsPage() {
  return (
    <section className="bg-white py-20 px-6 md:px-12">
      {/* Header */}
      <div className="text-center mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl mt-10 font-extrabold text-gray-800 mb-4"
        >
          Our <span className="text-orange-500">Products</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-gray-600 text-lg max-w-2xl mx-auto"
        >
          Discover our latest innovations — from advanced applications to
          powerful hardware solutions.
        </motion.p>
      </div>

      {/* Products Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-24">
        {products.map((product, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            whileHover={{ scale: 1.05 }}
            className={`relative rounded-3xl shadow-lg overflow-hidden p-8 text-center group cursor-pointer bg-gradient-to-b ${product.color}`}
          >
            {/* Floating Animation */}
            <motion.div
              animate={{ y: [0, -8, 0] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              className="text-7xl text-white mb-4"
            >
              {product.icon}
            </motion.div>

            <h3 className="text-2xl font-semibold text-white mb-2">
              {product.name}
            </h3>
            <p className="text-white/80 mb-4">{product.type}</p>

            {/* Status Badge */}
            <motion.span
              animate={
                product.status === "Coming Soon"
                  ? {
                      opacity: [0.6, 1, 0.6],
                      scale: [1, 1.05, 1],
                    }
                  : {}
              }
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className={`inline-block px-4 py-1 rounded-full text-sm font-semibold ${
                product.status === "Coming Soon"
                  ? "bg-white/30 text-white border border-white/50 backdrop-blur-sm"
                  : "bg-white text-orange-600"
              }`}
            >
              {product.status}
            </motion.span>

            {/* Overlay for Coming Soon */}
            {product.status === "Coming Soon" && (
              <div className="absolute inset-0 bg-black/40 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-700 flex items-center justify-center rounded-3xl">
                <p className="text-white text-lg font-semibold">
                  Launching Soon 🚀
                </p>
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
